export default "__VITE_ASSET__KOsYXgKzilUTyUmx29vzkQ__"